// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OpenResourceCard_wrapper__22P1e","icon":"OpenResourceCard_icon__1PzAO"};